export const skills = [
    {
      "id": 1,
      "skillName": "JavaScript",
      "skillDescription": "Experienced in JavaScript for DOM manipulation.",
      "skillSrc": "images/skills/javascript.png"
    },
    {
      "id": 2,
      "skillName": "TypeScript",
      "skillDescription": "Experienced in TypeScript.",
      "skillSrc": "images/skills/typescript.png"
    },
    {
      "id": 3,
      "skillName": "PHP",
      "skillDescription": "Experienced in PHP",
      "skillSrc": "images/skills/php.png"
    },
    {
      "id": 4,
      "skillName": "Node.js",
      "skillDescription": "Experienced in Node.js for building server-side applications.",
      "skillSrc": "images/skills/nodejs.png"
    },
    {
      "id": 5,
      "skillName": "Express",
      "skillDescription": "Experienced in Express.js for application routing.",
      "skillSrc": "images/skills/express.png"
    },
    {
      "id": 6,
      "skillName": "MongoDB",
      "skillDescription": "Experienced with MongoDB for document database creation and management.",
      "skillSrc": "images/skills/mongo-db-logo.png"
    },
    {
      "id": 7,
      "skillName": "MySQL",
      "skillDescription": "Experienced with MySQL for relational database creation and management.",
      "skillSrc": "images/skills/mysql.png"
    },
    {
      "id": 8,
      "skillName": "Firebase",
      "skillDescription": "Experienced in Firebase.",
      "skillSrc": "images/skills/firebase.png"
    },
    {
      "id": 9,
      "skillName": "AWS",
      "skillDescription": "Experienced in AWS.",
      "skillSrc": "images/skills/aws.png"
    },
    {
      "id": 10,
      "skillName": "React",
      "skillDescription": "Experienced with React for component-based web applications.",
      "skillSrc": "images/skills/reactjs.png"
    },
    {
      "id": 11,
      "skillName": "Angular",
      "skillDescription": "Experienced in Angular for component-based web applications.",
      "skillSrc": "images/skills/angular.png"
    },
    {
      "id": 12,
      "skillName": "Vue",
      "skillDescription": "Experienced in Vue for component-based web applications.",
      "skillSrc": "images/skills/vue.png"
    },
    {
      "id": 13,
      "skillName": "Photoshop",
      "skillDescription": "Experienced in Photoshop",
      "skillSrc": "images/skills/photoshop.png"
    },
    {
      "id": 14,
      "skillName": "Figma",
      "skillDescription": "Experienced in Figma",
      "skillSrc": "images/skills/figma.png"
    },
    {
      "id": 15,
      "skillName": "Sass/SCSS",
      "skillDescription": "Experienced in Sass/SCSS",
      "skillSrc": "images/skills/scss.png"
    },
    {
      "id": 16,
      "skillName": "HTML",
      "skillDescription": "Experienced in HTML5 for structuring web applications.",
      "skillSrc": "images/skills/html5.png"
    },
    {
      "id": 17,
      "skillName": "CSS",
      "skillDescription": "Experienced in CSS3 for DOM styling.",
      "skillSrc": "images/skills/css3.png"
    },
    {
      "id": 18,
      "skillName": "jQuery",
      "skillDescription": "Experienced in jQuery for traversing and manipulating the DOM.",
      "skillSrc": "images/skills/jquery.png"
    },
    {
      "id": 19,
      "skillName": "Bootstrap",
      "skillDescription": "Experienced in Twitter Bootstrap CSS for DOM styling.",
      "skillSrc": "images/skills/bootstrap.png"
    },
    {
      "id": 20,
      "skillName": "Material",
      "skillDescription": "Experienced with Material Design for DOM components and styling, with implementations in Angular (Angular Material) and React (MUI).",
      "skillSrc": "images/skills/material.png"
    },
    {
      "id": 21,
      "skillName": "Git Bash",
      "skillDescription": "Experienced in Git Bash as a Command Line Interfance, for version control.",
      "skillSrc": "images/skills/git.png"
    },    
    {
      "id": 22,
      "skillName": "Github Pages",
      "skillDescription": "Experienced in Github Pages for web hosting.",
      "skillSrc": "images/skills/githubpages.png"
    },
    {
      "id": 23,
      "skillName": "Tailwind CSS",
      "skillDescription": "Experienced in Tailwind CSS for DOM styling.",
      "skillSrc": "images/skills/tailwind.png"
    },
    
  ]

  export default {
    skills,
  }